import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../Containers/Config';

import { UPDATE_GAME_STATUS, UPDATE_GAME_STATUS_SUCCESS, UPDATE_GAME_STATUS_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* updateGameStatus({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/games/${payload?.type}`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: UPDATE_GAME_STATUS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_GAME_STATUS_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_GAME_STATUS_ERROR, payload: error });
  }
}

export function* watchupdateGameStatus() {
  yield takeEvery(UPDATE_GAME_STATUS, updateGameStatus);
}

function* updateGameStatusSaga() {
  yield all([fork(watchupdateGameStatus)]);
}

export default updateGameStatusSaga;
